import { useParams, Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { CONVENZIONI_DATA } from "@/data/convenzioniData";
import { PARTNER_DETTAGLI } from "@/data/partnerConvenzioniData";

export default function ConvenzioneDettaglioPage() {
  const { slug } = useParams();
  const conv = CONVENZIONI_DATA[slug];

  if (!conv) {
    return (
      <main id="main-content" className="py-20 text-center">
        <h1 className="text-2xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-4">Categoria non trovata</h1>
        <Link to="/convenzioni" className="text-[var(--confcom-blue)] font-medium hover:underline">Torna alle convenzioni</Link>
      </main>
    );
  }

  return (
    <main id="main-content">
      {/* Hero */}
      <section className="relative h-[280px] md:h-[340px] overflow-hidden">
        {conv.heroImage ? (
          <>
            <img src={conv.heroImage} alt={conv.titolo} className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0" style={{ backgroundColor: "rgba(4,30,66,0.82)" }} />
          </>
        ) : (
          <div className="absolute inset-0 bg-[var(--confcom-blue)]" />
        )}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative h-full flex flex-col justify-end pb-12">
          <Link to="/convenzioni" className="inline-flex items-center gap-2 text-sm text-white/70 hover:text-white mb-3 transition-colors"><ArrowLeft size={16} /> Convenzioni e Agevolazioni</Link>
          <h1 className="text-3xl md:text-4xl font-bold text-white font-['Encode_Sans_Semi_Condensed'] tracking-tight">{conv.titolo}</h1>
        </div>
      </section>

      <section className="py-16 bg-[#EBF5FF]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-[var(--confcom-text-secondary)] leading-relaxed mb-10">Presenta la tua <strong className="text-[var(--confcom-text-primary)]">Tessera Associativa Confcommercio Roma</strong> ai nostri partner per ottenere sconti, servizi aggiuntivi e condizioni di favore.</p>
          <h2 className="text-xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-6">Partner convenzionati</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {conv.partner.map((p) => {
              const partnerData = PARTNER_DETTAGLI[p.slug];
              return partnerData ? (
                <Link
                  key={p.slug}
                  to={`/convenzione-partner/${p.slug}`}
                  className="group bg-white rounded-xl border border-[var(--confcom-border)] overflow-hidden hover:border-[var(--confcom-blue)]/30 hover:shadow-md transition-all"
                  data-testid={`partner-card-${p.slug}`}
                >
                  {partnerData.image && (
                    <div
                      className="h-44 flex items-center justify-center p-6"
                      style={{ backgroundColor: partnerData.logoBg || "var(--confcom-blue)" }}
                    >
                      <img src={partnerData.image} alt={p.nome} className="max-h-28 w-auto object-contain" />
                    </div>
                  )}
                  <div className="p-4 flex items-center justify-between">
                    <span className="text-sm font-semibold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] group-hover:text-[var(--confcom-blue)] transition-colors line-clamp-2">{p.nome}</span>
                    <ArrowRight size={16} className="text-[var(--confcom-text-muted)] group-hover:text-[var(--confcom-blue)] shrink-0 ml-2 transition-colors" aria-hidden="true" />
                  </div>
                </Link>
              ) : (
                <div key={p.slug} className="bg-white rounded-xl border border-[var(--confcom-border)] overflow-hidden">
                  <div className="h-44 bg-[var(--confcom-bg-blue-light)] flex items-center justify-center">
                    <span className="text-xs text-[var(--confcom-text-muted)] font-medium">Logo in arrivo</span>
                  </div>
                  <div className="p-4 flex items-center justify-between">
                    <span className="text-sm font-semibold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] line-clamp-2">{p.nome}</span>
                    <span className="text-xs text-[var(--confcom-text-muted)] ml-2 whitespace-nowrap">In aggiornamento</span>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="mt-10 p-6 bg-white rounded-xl border border-[var(--confcom-border)]">
            <p className="text-sm text-[var(--confcom-text-secondary)]"><strong>Vuoi attivare una convenzione?</strong> Contattaci: convenzioni@confcommercioroma.it</p>
            <p className="text-sm text-[var(--confcom-text-muted)] mt-2">Supporto soci: Tel 06.68437500-755 | associati@confcommercioroma.it | Numero verde: 800 915 915</p>
          </div>
        </div>
      </section>
    </main>
  );
}
